import { render, staticRenderFns } from "./PackageStoreTabMenu.vue?vue&type=template&id=e0441c92&scoped=true"
import script from "./PackageStoreTabMenu.vue?vue&type=script&lang=js"
export * from "./PackageStoreTabMenu.vue?vue&type=script&lang=js"
import style0 from "./PackageStoreTabMenu.vue?vue&type=style&index=0&id=e0441c92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../production-parity-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0441c92",
  null
  
)

export default component.exports